// IndexedDB-backed identity store.
//
// 存什么：
//   - device_id (string)
//   - token     (string，phone HMAC token，与 GW EAR_DEV_TOKENS 对齐)
//   - alias     (可选，用户可改的 phone 名)
//   - gw_url    (主入口 https URL，默认 ear-sgp，后续切 fallback 时不动这里)
//   - created_at (ms)
//
// 不存什么：
//   - 任何 OAuth / Anthropic API Key（v1.2 决议：不需要）
//   - 任何明文密码（PWA 不要密码）
//
// 安全姿态：
//   - 仅 same-origin 访问（IndexedDB 默认）
//   - 不加密存（v1.2 简化），靠 HTTPS + 同源 + iOS keychain bind ASWebAuthenticationSession 不在范围
//   - 想清空 → tokenStore.clear()
//   - 后续真配对协议（Day-7）改成短期 token + refresh

import { openDB, type IDBPDatabase } from "idb";

const DB_NAME = "ear-cc";
const DB_VERSION = 1;
const STORE = "identity";
const KEY = "self";

export interface Identity {
  device_id: string;
  token: string;
  alias: string;
  gw_url: string;
  created_at: number;
}

let dbPromise: Promise<IDBPDatabase> | null = null;

function getDB(): Promise<IDBPDatabase> {
  if (!dbPromise) {
    dbPromise = openDB(DB_NAME, DB_VERSION, {
      upgrade(db) {
        if (!db.objectStoreNames.contains(STORE)) {
          db.createObjectStore(STORE);
        }
      }
    });
  }
  return dbPromise;
}

export const tokenStore = {
  async getIdentity(): Promise<Identity | null> {
    const db = await getDB();
    return (await db.get(STORE, KEY)) ?? null;
  },

  async setIdentity(id: Identity): Promise<void> {
    const db = await getDB();
    await db.put(STORE, id, KEY);
  },

  async clear(): Promise<void> {
    const db = await getDB();
    await db.delete(STORE, KEY);
  }
};
